<script lang="ts">
    import ToolBoxModal from "../toolbox/ToolBoxModal.svelte";
    import { _ } from "svelte-i18n";
    import DataLayerSettings from "./data/DataLayerSettings.svelte";
    import type { LayersToolBoxManager } from "./LayersToolBoxManager";
    import { get } from "svelte/store";

    export let manager: LayersToolBoxManager;
    const baseLayers = manager.getBaseLayers();
    const openToolBox = manager.getOpenToolBoxStore();
    const activeBaseLayer = manager.getActiveBaseLayerStore();
    const dataLayerOptions = manager.getDataLayerOptions();
    const imageryVisible = manager.getImageryVisisbleStore();
    let imageryInputValue = $imageryVisible ? 1 : 0;

    console.log(imageryInputValue);

    let activeBaseLayerId: string = $activeBaseLayer.id;
    $: {
        const baseLayer = baseLayers.find(
            (x) => x.id == activeBaseLayerId
        );
        if (typeof baseLayer !== "undefined") activeBaseLayer.set(baseLayer);
    }
    $: {
        $imageryVisible = imageryInputValue == 1;
    }

    let backgroundsCollapsed: boolean = false;
    function expandCollapseBackgrounds() {
        backgroundsCollapsed = !backgroundsCollapsed;
    }

    let baseLayersCollapsed: boolean = false;
    function expandCollapseBaseLayers() {
        baseLayersCollapsed = !baseLayersCollapsed;
    }

    let dataLayersCollapsed: boolean = false;
    const expandCollapseDataLayers = () => {
        dataLayersCollapsed = !dataLayersCollapsed;
    };
</script>

<ToolBoxModal
    isOpen={$openToolBox === "baselayers"}
    title={$_("impact.map.layersToolbox.title")}>
    <h4 on:click={() => expandCollapseBackgrounds()} on:keydown={() => {}}>
        {#if backgroundsCollapsed}
            <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                ><path
                    d="M6.63 4c-1.103.079-.691-.113-1.329.353a1.117 1.117 0 00.136 1.648l5.892 4.721-5.892 4.722a1.117 1.117 0 00-.136 1.648 1.31 1.31 0 001.762.127l7-5.609a1.12 1.12 0 000-1.775l-7-5.609L6.63 4z"
                    fill="currentColor" /></svg>
        {:else}
            <svg
                viewBox="0 0 20 20"
                id="iD-icon-down"
                xmlns="http://www.w3.org/2000/svg"
                ><path
                    d="M10 14.999c.453.015.695-.094.949-.336.254-.243 5.25-5.855 6-6.692a1.159 1.159 0 00-.136-1.685 1.29 1.29 0 00-1.762.13c-3.684 4.108-4.368 4.82-5.051 5.583-4.301-4.797-4.301-4.747-5.051-5.583a1.29 1.29 0 00-1.762-.13 1.159 1.159 0 00-.136 1.685c5.25 5.855 5.715 6.371 6 6.692.261.226.496.32.949.336z"
                    fill="currentColor" /></svg>
        {/if}
        {$_("impact.map.layersToolbox.backgrounds.title")}
    </h4>
    {#if !backgroundsCollapsed}
        <ul class="list-group">
                    <li class="list-group-item p-2">
                        <input
                            class="form-check-input me-1"
                            type="radio"
                            id="imageryNo"
                            name="backgroundLayers"
                            value={0}
                            bind:group={imageryInputValue} />
                        <label class="form-check-label" for="imageryNo">
                            {$_("impact.map.layersToolbox.backgrounds.default")}
                        </label>
                    </li>              
                    <li class="list-group-item p-2">
                        <!-- @ts-nocheck -->
                        <input
                            class="form-check-input me-1"
                            type="radio"
                            id="imageryYes"
                            name="backgroundLayers"
                            value={1}
                            bind:group={imageryInputValue} />
                        <label class="form-check-label" for="imageryYes">
                            {$_("impact.map.layersToolbox.backgrounds.imagery")}
                        </label>
                    </li>
        </ul>
    {/if}
    <h4
        on:click={() => expandCollapseBaseLayers()}
        on:keydown={() => {}}
        class="mt-2">
        {#if baseLayersCollapsed}
            <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                ><path
                    d="M6.63 4c-1.103.079-.691-.113-1.329.353a1.117 1.117 0 00.136 1.648l5.892 4.721-5.892 4.722a1.117 1.117 0 00-.136 1.648 1.31 1.31 0 001.762.127l7-5.609a1.12 1.12 0 000-1.775l-7-5.609L6.63 4z"
                    fill="currentColor" /></svg>
        {:else}
            <svg
                viewBox="0 0 20 20"
                id="iD-icon-down"
                xmlns="http://www.w3.org/2000/svg"
                ><path
                    d="M10 14.999c.453.015.695-.094.949-.336.254-.243 5.25-5.855 6-6.692a1.159 1.159 0 00-.136-1.685 1.29 1.29 0 00-1.762.13c-3.684 4.108-4.368 4.82-5.051 5.583-4.301-4.797-4.301-4.747-5.051-5.583a1.29 1.29 0 00-1.762-.13 1.159 1.159 0 00-.136 1.685c5.25 5.855 5.715 6.371 6 6.692.261.226.496.32.949.336z"
                    fill="currentColor" /></svg>
        {/if}
        {$_("impact.map.layersToolbox.baseLayers.title")}
    </h4>
    {#if !baseLayersCollapsed}
        <ul class="list-group">
            {#each baseLayers as layer, i}
                <li class="list-group-item p-2">
                    <input
                        class="form-check-input me-1"
                        type="radio"
                        id={"baseLayer" + i}
                        name="baseLayers"
                        value={layer.id}
                        bind:group={activeBaseLayerId} />
                    <label class="form-check-label" for={"baseLayer" + i}>
                        {$_(`impact.map.layersToolbox.baseLayers.${layer.id}`)}
                    </label>
                </li>
            {/each}
        </ul>
    {/if}
    <h4
        on:click={() => expandCollapseDataLayers()}
        on:keydown={() => {}}
        class="mt-2">
        {#if dataLayersCollapsed}
            <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                ><path
                    d="M6.63 4c-1.103.079-.691-.113-1.329.353a1.117 1.117 0 00.136 1.648l5.892 4.721-5.892 4.722a1.117 1.117 0 00-.136 1.648 1.31 1.31 0 001.762.127l7-5.609a1.12 1.12 0 000-1.775l-7-5.609L6.63 4z"
                    fill="currentColor" /></svg>
        {:else}
            <svg
                viewBox="0 0 20 20"
                id="iD-icon-down"
                xmlns="http://www.w3.org/2000/svg"
                ><path
                    d="M10 14.999c.453.015.695-.094.949-.336.254-.243 5.25-5.855 6-6.692a1.159 1.159 0 00-.136-1.685 1.29 1.29 0 00-1.762.13c-3.684 4.108-4.368 4.82-5.051 5.583-4.301-4.797-4.301-4.747-5.051-5.583a1.29 1.29 0 00-1.762-.13 1.159 1.159 0 00-.136 1.685c5.25 5.855 5.715 6.371 6 6.692.261.226.496.32.949.336z"
                    fill="currentColor" /></svg>
        {/if}
        {$_("impact.map.layersToolbox.dataLayers.title")}
    </h4>
    {#if !dataLayersCollapsed}
        <ul class="list-group">
            {#each dataLayerOptions as dataLayer}
                <li class="list-group-item p-2">
                    <DataLayerSettings settings={dataLayer} />
                </li>
            {/each}
        </ul>
    {/if}
</ToolBoxModal>

<style>
    svg {
        width: 20px;
        display: inline;
    }
</style>
